import { render } from "./ListaEncerramento.vue?vue&type=template&id=09719377&scoped=true"
import script from "./ListaEncerramento.vue?vue&type=script&lang=js"
export * from "./ListaEncerramento.vue?vue&type=script&lang=js"

import "./ListaEncerramento.vue?vue&type=style&index=0&id=09719377&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09719377"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBtn,QTd});
